module.exports = __webpack_public_path__ + "img/malmo-ff.54120693.png";